module.exports = __webpack_public_path__ + "static/media/logo-menu.8deec197.svg";